import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NavigationService } from 'src/app/_services/navigation.service';
import { WebinarAccessService } from 'src/app/_services/webinar.service';
import { WebsiteService } from 'src/app/_services/website.service';
import { CaptureLeadComponent } from 'src/app/Components/industry-engagements/capture-lead/capture-lead.component';

@Component({
  selector: 'app-download-info-sheet',
  templateUrl: './download-info-sheet.component.html',
  styleUrls: ['./download-info-sheet.component.scss']
})
export class DownloadInfoSheetComponent implements OnInit {

  selectedWebinar: any = null;
    showAccessForm = false;
    @ViewChild(CaptureLeadComponent) accessForm!: CaptureLeadComponent;
  
    constructor(
      public navigationService: NavigationService,
      @Inject(PLATFORM_ID) private platformId: Object,
      private webinarAccessService: WebinarAccessService,
      private toastr: ToastrService,
      private networkCall: WebsiteService,
    ) { }
  
    ngOnInit(): void {
    }
  
    get hasAccess(): boolean {
      return this.webinarAccessService.hasAccess();
    }
    selectedLink: string | null = null;
    thankYouLink: string | null = null;
    selectedTitle: string = '';
  
    async openResource(url: string) {
      if (!isPlatformBrowser(this.platformId)) return;
  
      if (this.hasAccess) {
        window.open(url, '_blank');
        return;
      }
  
      this.selectedLink = url;
  
      const accessModalEl = document.getElementById('CaptureLeadForm');
      if (accessModalEl) {
        const bootstrap = await import('bootstrap');
        new bootstrap.Modal(accessModalEl).show();
      }
    }
  
    downloadingMap: { [key: string]: boolean } = {};
    async openResourcePDF(url: string, title: string) {
      if (!isPlatformBrowser(this.platformId)) return;
    
      const isPdf = url?.toLowerCase().includes('.pdf');
    
      if (this.hasAccess) {
    
        const email = sessionStorage.getItem('userEmail') || '';
    
        if (!isPdf) {
          return;
        }
    
        if (!email) {
          this.toastr.warning('Please submit the form once to receive the PDF.');
    
          this.selectedLink = url;
          this.selectedTitle = title;
    
          const accessModalEl = document.getElementById('CaptureLeadForm');
          if (accessModalEl) {
            const bootstrap = await import('bootstrap');
            new bootstrap.Modal(accessModalEl).show();
          }
          return;
        }
    
        // ✅ START LOADING
        this.downloadingMap[url] = true;
    
        const fullPdfUrl = 'https://www.trinka.ai' + url;
    
        const emailPayload = {
          email_id: email,
          pdf_url: fullPdfUrl,
          title: title,
          name: localStorage.getItem('userName') || ''
        };
    
        this.networkCall.sendResourceEmail(emailPayload).subscribe(
          () => {
            this.toastr.success(`PDF has been sent to your email ${email}`);
          },
          () => {
            this.toastr.error('Failed to send PDF email');
          }
        ).add(() => {
          // ✅ ALWAYS STOP LOADING
          this.downloadingMap[url] = false;
        });
    
        return;
      }
    
      // ❌ No access → open modal
      this.selectedLink = url;
      this.selectedTitle = title;
    
      const accessModalEl = document.getElementById('CaptureLeadForm');
      if (accessModalEl) {
        const bootstrap = await import('bootstrap');
        new bootstrap.Modal(accessModalEl).show();
      }
    }
  
    onFormSubmitted(url: string) {
      // Grant access
      this.webinarAccessService.grantAccess();
  
      // Set thank-you link for Open Now button
      this.thankYouLink = url;
  
      // Do NOT hide the modal — leave it open
      // You can optionally show the thank you section inside the modal
    }

}
